import type { ReactNode, CSSProperties } from 'react';

interface CardProps {
  children: ReactNode;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  shadow?: 'none' | 'sm' | 'md';
  style?: CSSProperties;
}

const PADDING = { none: '0', sm: '12px', md: '20px', lg: '24px' };
const SHADOW = {
  none: 'none',
  sm: '0 1px 2px rgba(0,0,0,0.05)',
  md: '0 1px 3px rgba(0,0,0,0.05)',
};

export function Card({ children, padding = 'md', shadow = 'sm', style }: CardProps) {
  return (
    <div style={{
      background: 'white',
      borderRadius: '16px',
      border: '1px solid #e2e8f0',
      boxShadow: SHADOW[shadow],
      padding: PADDING[padding],
      overflow: 'hidden',
      ...style,
    }}>
      {children}
    </div>
  );
}
